module.exports = __webpack_public_path__ + "static/media/bug.31e17bb9.svg";